export default {
  '404Message': 'غير موجود',
  addHostNotes: 'إضافة ملاحظات للمضيف',
  addParticipant: '{{tierLabel}} إضافي',
  and: 'و',
  apply: 'تطبيق',
  bookBulkErrorByCard:
    'حدثت مشكلة أثناء تأكيد حجزك. لم يتم تحصيل أي مبلغ من بطاقتك.',
  bookBulkErrorByMemberCharge: 'اسم العائلة أو رقم العضوية غير صحيح.',
  bookBulkErrorByNotEnoughSeats:
    'لا توجد مقاعد كافية متاحة لهذه الجلسة. يرجى تجربة جلسة أخرى.',
  bookBulkErrorByRoomCharge: 'اسم العائلة أو رقم الغرفة غير صحيح.',
  brandAggreementText:
    'أوافق، أو أؤكد بخلاف ذلك أنني مفوض نيابة عن المشارك(ين) للموافقة على شروط وأحكام',
  browseAllExperieces: 'تصفح جميع التجارب',
  cancellable: 'قابل للإلغاء',
  cancelled: 'ملغى',
  cancelling: 'جارٍ الإلغاء',
  cardNumber: 'رقم البطاقة',
  cardNumberIncomplete: 'رقم البطاقة غير مكتمل',
  chargeValidation: 'رقم الغرفة واسم العائلة مطلوبان',
  checkout: 'الدفع',
  complete: 'إكمال',
  complimentary: 'مجاني',
  confirm: 'تأكيد',
  confirmationHeader: 'تم حجز تجربتك!',
  confirmationText:
    'تم إرسال بريد إلكتروني للتأكيد إلى {{email}} يتضمن تفاصيل إضافية',
  confirmationEmailSent:
    'لقد أرسلنا تأكيدك إلى {{email}} مع المزيد من التفاصيل.',
  confirmCancellation: 'تأكيد الإلغاء',
  confirmReservation: 'تأكيد الحجز',
  creditCard: 'بطاقة ائتمان',
  creditCodeHasAlreadyBeenApplied: 'تم تطبيق رمز الرصيد بالفعل',
  curatedRecommendations: 'توصيات مختارة',
  currentPointsBalance: 'رصيد النقاط الحالي: {{count, number}}',
  deadlinePassed: 'انقضى الموعد النهائي',
  discount: 'الخصم',
  discountCode: 'رمز الخصم',
  duplicatePurchaserText: 'نفس المشتري',
  duration: 'المدة',
  editParticipants: 'تعديل المشاركين',
  editParticipantsDetails: 'تعديل تفاصيل المشاركين',
  email: 'البريد الإلكتروني',
  emailValidation: {
    emailRequiredText: 'البريد الإلكتروني مطلوب',
    invalidEmail: 'عنوان البريد الإلكتروني غير صالح',
    not_specified: 'عنوان البريد الإلكتروني غير صحيح',
  },
  enterParticipantInfoText: 'يرجى إدخال التفاصيل المطلوبة للمتابعة إلى الدفع.',
  experienceCartCheckout: 'دفع سلة التجارب',
  experienceCheckoutCompleted: 'تم إكمال دفع التجربة',
  experienceLimitReached:
    'عذرًا، وصلت هذه التجربة إلى الحد الأقصى لعدد المشاركين',
  experiencesAvailableAroundYourBookingDate: 'التجارب المتاحة حول تاريخ حجزك',
  firstName: 'الاسم الأول',
  firstNameValidation: 'الاسم الأول مطلوب',
  fullName: 'الاسم الكامل',
  guestNameIsRequired: 'اسم الضيف مطلوب',
  hyattTermsAndConditions: 'الشروط والأحكام',
  hyattTermsAndConditionsAgreement:
    'بتأكيد هذا الحجز، أوافق على سياسة الإلغاء. كما قرأت وأقر باستخدام معلوماتي الشخصية وفقًا لـ',
  hyattTermsAndConditionsLink: 'سياسات خصوصية Hyatt',
  hyattWaiverLink: 'إخلاء المسؤولية العام',
  hyattWaiverText:
    'بشراء هذه التجربة، أوافق وأفهم وأقر، نيابة عن نفسي ونيابة عن أي فرد يشارك في التجربة التي اشتريتها (إن وجد)، على ما يلي',
  includes: 'يشمل',
  invalidMemberNumber: 'رقم العضوية غير صالح',
  invalidPhoneNumber: 'رقم الهاتف غير صالح',
  invalidRoomNumber: 'رقم الغرفة غير صالح',
  invalidRoomNumberLegacy: 'رقم الغرفة أو رمز التأكيد غير صالح',
  isReqd: 'مطلوب',
  joinBook: 'الانضمام والحجز',
  kicc: 'الدفع السهل',
  lastName: 'اسم العائلة',
  lastNameValidation: 'اسم العائلة مطلوب',
  lastNameValidationError: 'اسم العائلة مطلوب',
  memberCharge: 'الخصم من حساب العضو',
  memberNumber: 'رقم العضوية',
  memberNumberValidation: 'رقم العضوية مطلوب',
  moreExperiencesYouMightLike: 'المزيد من التجارب التي قد تعجبك',
  networkErrorDiscountCode: 'حدث خطأ من جانبنا',
  noBookingsAvailable: 'لا توجد حجوزات متاحة',
  noCancellations: 'لا توجد عمليات إلغاء',
  nonHotelGuest: 'ليس ضيف فندق',
  noOtherSessionsAvailableForThisExperience:
    'لا توجد جلسات أخرى متاحة لهذه التجربة.',
  notEnoughPoints: 'النقاط غير كافية',
  notEnoughPointsDescription:
    'ليس لديك نقاط World of Hyatt كافية لإتمام هذا الشراء.',
  noTimesAvailable: 'لا توجد أوقات متاحة',
  onlyOneCouponCodeAllowed: 'يُسمح برمز قسيمة واحد فقط',
  onPropertyGuest: 'ضيف داخل الفندق',
  optionalEmail: 'البريد الإلكتروني: (اختياري)',
  participant: 'المشارك',
  participantDetails: 'التفاصيل',
  participantFieldPlaceholder: 'أضف مشاركًا جديدًا أو اختر مشاركًا موجودًا',
  participantFirstNameValidation: 'الاسم الأول للمشارك مطلوب',
  participantLastNameValidation: 'اسم عائلة المشارك مطلوب',
  participants: 'المشاركون',
  payment: 'الدفع',
  paymentMethod: 'طريقة الدفع',
  payWith: 'الدفع بـ',
  payWithCreditCard: 'الدفع ببطاقة الائتمان',
  payWithHyattPoints: 'الدفع بنقاط Hyatt',
  payWithMemberCharge: 'الدفع بخصم حساب العضو',
  payWithRoomCharge: 'الدفع بخصم الغرفة',
  phone: 'الهاتف',
  'phone:': 'الهاتف',
  phoneNumber: 'رقم الهاتف',
  phoneValidation: {
    'Invalid Phone Number': 'رقم الهاتف غير صالح',
    not_specified: 'غير صالح',
    phoneRequiredText: 'رقم الهاتف مطلوب',
  },
  pleaseSignIn: 'يرجى تسجيل الدخول',
  pmsDateValidationErrorMessage:
    'عذرًا! لا يقع تاريخ التجربة بين تاريخ وصولك ومغادرتك.',
  pmsValidationErrorMessage:
    'اسم العائلة أو رقم الغرفة أو رقم التأكيد غير صالح',
  points: 'نقاط',
  pointsWithCount_one: '{{count, number}} نقطة',
  pointsWithCount_other: '{{count, number}} نقاط',
  preArrivalGuest: 'ضيف قبل الوصول',
  previouslyRefunded: 'تم استرداده مسبقًا',
  priceDisclaimer: 'يشمل الرسوم قبل الضرائب',
  private: 'خاص',
  promo: 'عرض ترويجي',
  promoCode: 'الرمز الترويجي',
  promoOrFind: 'رمز ترويجي أو رمز رصيد FIND',
  purchaser: 'المشتري',
  purchaserInformation: 'معلومات المشتري',
  refund: 'استرداد',
  remainingBalance: 'الرصيد المتبقي',
  removeCode: 'إزالة الرمز',
  removeParticipant: 'إزالة',
  requestToBookConfirmationText: 'تم إرسال بريد إلكتروني للتأكيد إلى {{email}}',
  requiredFieldIndicator: '* يشير إلى حقل مطلوب',
  requiredPhoneNumber: 'رقم الهاتف مطلوب',
  reservationCancelled: 'تم إلغاء الحجز',
  reservationCode: 'رقم الحجز/التأكيد',
  reservationSummary: 'ملخص الحجز',
  reviewCancellation: 'مراجعة الإلغاء',
  reviewCompleteHeader: 'المراجعة والإتمام',
  reviewReschedule: 'حجزك',
  roomCharge: 'الخصم من الغرفة',
  roomNumber: 'رقم الغرفة',
  roomNumberIsRequired: 'رقم الغرفة مطلوب',
  roomNumberIsRequiredLegacy: 'رقم الغرفة أو رمز التأكيد مطلوب',
  roomNumberLegacy: 'رقم الغرفة / رمز التأكيد',
  roomOrReservationNumber: 'رقم الغرفة أو رقم التأكيد',
  roomOrReservationNumberIsRequired: 'رقم الغرفة أو رقم التأكيد مطلوب',
  selectADateAndTime: 'اختر تاريخًا ووقتًا',
  selectAReservationToCancel: 'اختر حجزًا لإلغائه',
  selectAReservationToReschedule: 'اختر حجزًا لإعادة جدولته',
  signAndJoin: 'سجّل الدخول أو انضم للحجز',
  signAndJoinDescription:
    'تجارب World of Hyatt FIND حصرية لأعضاء World of Hyatt. سجّل الدخول أو انضم لتحجز وتكسب النقاط. لا تفضل الانضمام؟ يمكنك الحجز بتجارب غير حصرية بإزالة تجربة World of Hyatt من سلتك.',
  signInBook: 'تسجيل الدخول والحجز',
  similarExperiencesAvailableToBookDirectly: 'تجارب مماثلة متاحة للحجز مباشرة',
  somethingWentWrong: 'حدث خطأ ما',
  subTotal: 'المجموع الفرعي',
  termsAggreementValidation: 'يرجى الموافقة على الشروط',
  theHotel: 'الفندق',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'لا يمكن إلغاء هذا الحجز بعد الآن. يرجى مراسلة {{brandEmail}}',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'لا يمكن إعادة جدولة هذا الحجز بعد الآن. يرجى مراسلة {{brandEmail}}',
  thisReservationCannotBeCancelled: 'لا يمكن إلغاء هذا الحجز',
  thisReservationCannotBeRescheduled: 'لا يمكن إعادة جدولة هذا الحجز',
  thisReservationHasAlreadyBeenCancelled: 'تم إلغاء هذا الحجز بالفعل',
  total: 'الإجمالي',
  viewAll: 'عرض جميع التجارب',
  viewExperiences: 'عرض التجارب',
  waiting: 'جارٍ الانتظار...',
  worldOfHyattPoints: 'نقاط World of Hyatt',
  youPaid: 'لقد دفعت',
  youreBooked: 'تم حجزك',
  yourRefund: 'رصيد الاسترداد الخاص بك',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'ستتم معالجة الاسترداد إلى وسيلة الدفع الأصلية.',
  yourReservationWasRescheduledTo: 'تمت إعادة جدولة حجزك إلى',
  resourceSelectionTitle: 'اختر خياراتك',
  resourceSelectionDescription: 'اختر خيارًا لكل عنصر في حجزك.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'اختر {{attributeName}}',
  resourceValueSoldOut: '{{label}} (نفدت الكمية)',
  resourceValueUnavailableWith: '{{label}} (غير متاح مع {{picks}})',
  resourceOptionsUnavailable:
    'تعذر تحميل الخيارات لهذا الوقت. يرجى المحاولة مرة أخرى.',
  resourceOptionsRetry: 'حاول مرة أخرى',
  changeResourceSelections: 'غيّر اختياراتك',
};
